const API_URL = process.env.REACT_APP_CLOUD_RUN_API_URL;

export interface ReturningUserData {
  email: string;
  coach_preference: string;
  track: string;
  activity_type: string;
  segment: string;
  training_mode: string;
}

export async function submitReturningUser(data: ReturningUserData): Promise<void> {
  if (!API_URL) {
    throw new Error('REACT_APP_CLOUD_RUN_API_URL is not configured');
  }

  const response = await fetch(`${API_URL}/submit-returning-user`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: `HTTP ${response.status}` }));
    throw new Error(body.error || `HTTP ${response.status}`);
  }
}
